module.exports = __webpack_public_path__ + "img/hat-bg_12.be48f495.png";